/**
 * GSAP 3D Card Tilt Effect
 * Cursor-driven perspective tilt animation
 */

function initCardTilt(selector = '.tilt-card') {
  if (typeof gsap === 'undefined') {
    console.warn('GSAP not loaded');
    return;
  }

  const cards = document.querySelectorAll(selector);
  
  cards.forEach(card => {
    const inner = card.querySelector('.tilt-card__inner') || card;
    
    // Mouse move handler
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left; // x position within the element
      const y = e.clientY - rect.top;  // y position within the element
      
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      
      // Calculate rotation (max 15 degrees)
      const rotateX = ((y - centerY) / centerY) * -15;
      const rotateY = ((x - centerX) / centerX) * 15;
      
      // Animate with GSAP
      gsap.to(inner, {
        duration: 0.5,
        rotateX: rotateX,
        rotateY: rotateY,
        transformPerspective: 1000,
        ease: 'power2.out'
      });
    });
    
    // Mouse leave handler - return to original position
    card.addEventListener('mouseleave', () => {
      gsap.to(inner, {
        duration: 0.5,
        rotateX: 0,
        rotateY: 0,
        ease: 'power2.out'
      });
    });
  });
}

// Auto-initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCardTilt());
} else {
  initCardTilt();
}

// Export for manual initialization
window.initCardTilt = initCardTilt;
